<template>
    <section :class="['hero-carousel', css]">
        <div v-if="slides.length > 0" class="hero-carousel__slider">
            <div class="swiper hero-carousel-slider">
                <div class="swiper-wrapper">
                    <div v-for="(slide, i) in slides" class="swiper-slide">
                        <hero-carousel-slide :slide="slide" :key="i" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts">
    import { onMounted, ref, Ref, PropType } from "vue";
    import { ISlide } from "../helpers/HeroCarouselTypes";
    import Swiper, { Pagination, Autoplay } from 'swiper';

    export default {
        name: 'HeroCarousel',
        props: {
            slides: {
                type: Object as PropType<ISlide[]>,
                required: true,
            },
            css: {
                type: String,
                required: false,
                default: ""
            }
        },
        setup() {
            let slider: Ref<Swiper>;

            onMounted(() => {
                Swiper.use([Pagination, Autoplay]);

                slider = ref(new Swiper('.hero-carousel-slider', {
                    slidesPerView: 1,
                    centeredSlides: true,
                    autoplay: {
                        delay: 4000,
                        disableOnInteraction: false
                    }
                }));
            })
        }
    };
</script>
